import featuredItems from './featuredItems';
import announcement from './announcement';
import hero from './hero';
import hiring from './hiring';
import image from './image';
import intro from './intro';
import partners from './partners';
import relatedWorks from './relatedWorks';
import row from './row';
import text_image_row from './text_image_row';
import text_image_stack from './text_image_stack';

// Contact Modules

import ContactForm from './contact/ContactUsForm';

// Work Modules

import WorkCategoryContent from './work/CategoryContent';
import WorkCategoryHeader from './work/CategoryHeader';
import WorkHeader from './work/Header';
import WorkImageTextCol from './work/ImageTextColumn';
import WorkImageTextRow from './work/ImageTextRow';
import WorkMultiImageText from './work/MultiImageText';
import WorkTwoColumnText from './work/TwoColumnText';
import WorkOneColumnText from './work/OneColumnText';
import WorkRelatedArticles from './work/RelatedArticles';

// Misc

import FourOhFour from './FourOhFour';

// hardcoded modules
import hcAbout from './hcAbout';
import hcAboutIntro from './hcAboutIntro';

const modules = { featuredItems, announcement, hero, hiring, image, intro, partners, text_image_row, text_image_stack, relatedWorks, row, hcAbout, hcAboutIntro };

const addModule = (function(struct) {
  return function(modz) {
    const name = modz.name;
    // eslint-disable-next-line no-param-reassign
    struct[name] = modz;
  };
}(modules));

addModule(ContactForm);

addModule(FourOhFour);

addModule(WorkCategoryContent);
addModule(WorkCategoryHeader);
addModule(WorkHeader);
addModule(WorkImageTextCol);
addModule(WorkImageTextRow);
addModule(WorkMultiImageText);
addModule(WorkTwoColumnText);
addModule(WorkOneColumnText);
addModule(WorkRelatedArticles);


export default modules;



// WEBPACK FOOTER //
// ./src/modules/index.js